"use client";

import type { JSX } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faClock } from "@fortawesome/pro-regular-svg-icons";
import { getTimeFormat, localTimeToDayjs } from "~/lib/utils";
import { useTranslations } from "~/hooks/useTranslations";
import { PlainMessage } from "@bufbuild/protobuf";
import { EventDetails } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { isAzetShop } from "~/lib/client/isAzetShop";

interface ITimeInformation {
  eventDetails: PlainMessage<EventDetails>;
  lng: string;
}

export function TimeInformation({
  eventDetails,
  lng,
}: Readonly<ITimeInformation>): JSX.Element {
  const t = useTranslations();
  const isAzet = isAzetShop();

  const start = localTimeToDayjs(eventDetails.event?.start);
  const doorsOpen = localTimeToDayjs(eventDetails.doorsOpen);
  const end = localTimeToDayjs(eventDetails.event?.end);
  return (
    <div className="flex shrink-0 flex-col gap-2">
      <div className="flex flex-row items-center justify-start gap-2">
        <FontAwesomeIcon icon={faCalendar} />
        <span className="shrink-0 text-md font-bold leading-md">
          {start.format("DD.MM.YYYY")}
        </span>
      </div>
      <div className="flex flex-col gap-2 md:flex-row">
        {!isAzet && (
          <span className="flex flex-row items-center justify-start gap-2">
            <FontAwesomeIcon icon={faClock} />
            <span className="font-bold">{t.entry}</span>
            <span className="shrink-0 text-md leading-md">
              {doorsOpen.format("HH:mm")} {getTimeFormat(doorsOpen, lng)}
            </span>
          </span>
        )}
        <span className="flex flex-row items-center justify-start gap-2 pl-6 md:pl-0">
          <span className="font-bold">{t.start}</span>
          <span className="shrink-0 text-md leading-md">
            {start.format("HH:mm")} {getTimeFormat(start, lng)}
          </span>
        </span>
        {!isAzet && (
          <span className="flex flex-row items-center justify-start gap-2 pl-6 md:pl-0">
            <span className="font-bold">{t.end}</span>
            <span className="shrink-0 text-md leading-md">
              {end.format("HH:mm")} {getTimeFormat(end, lng)}
            </span>
          </span>
        )}
      </div>
    </div>
  );
}
